export { default as PatientPreviewTabs } from './PatientPreviewTabs';